'use strict';

import CustomAutoscroll from './turbo/CustomAutoscroll';
import FormActionHandler from './turbo/FormActionHandler';
import GetFormHandler from './turbo/GetFormHandler';
import MissingFrameHandler from './turbo/MissingFrameHandler';

new CustomAutoscroll();
new FormActionHandler();
new GetFormHandler();
new MissingFrameHandler();
